import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import {
  // Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "components/ui";
import {
  AddBadgeAction,
  UpdateBadgeAction,
} from "store/middlewares/dataManagement/badge";
import { InputTextarea, SubmitLoaderButton } from "components/atoms";

function ModalBadge({ row }) {
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);

  //--------------------- image change function ------------------------------

  const handleSubmit = (values) => {
    let tempObj = {
      title: values.title.trim(),
      description: values.description,
      to: Number(values.to),
      from: values.from ? Number(values.from) : 0,onSuccess: () => formik.setSubmitting(false),
    onError: () => {
      setFormError(true);
      formik.setSubmitting(false);
    },
    };

    // only add type if it has value
    if (values.type && values.type.trim()) {
      tempObj.type = values.type.trim();
    }

    if (row) {
      tempObj.id = row?.id;
      dispatch(UpdateBadgeAction(tempObj));
    } else {
      dispatch(AddBadgeAction(tempObj));
    }
  };
  const formik = useFormik({
    initialValues: {
      title: row?.title ? row?.title : "",
      description: row?.description ? row?.description : "",
      to: row?.to ? row?.to : null,
      from: row?.from ?? null,
      type: row?.type ?? null,
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required("Title is required")
        .min(3, "Minimum 3 characters required"),
      to: Yup.number().required("To is required"),
      from: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
          originalValue === "" ? null : value,
        ),
      type: Yup.string()
        .nullable()
        .transform((value, originalValue) =>
          originalValue === "" ? null : value,
        ),
      description: Yup.string()
        .required("Description is required")
        .min(3, "Minimum 3 characters required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid gap-5 lg:gap-7.5 mx-auto">
        <Card className="min-w-full">
          <CardHeader>
            <CardTitle>Badge</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-5">
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32">Title</Label>
              <Input
                error={formik.errors.title && formik.touched.title}
                errorMsg={formik.errors.title}
                value={formik.values.title}
                type="text"
                name="title"
                isSpace={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter title"
                className={"!py-0 w-full"}
                maxLength={50}
              />
            </div>
            <div className="flex items-start flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32 mt-4">Description</Label>
              <InputTextarea
                error={formik.errors.description && formik.touched.description}
                errorMsg={formik.errors.description}
                value={formik.values.description}
                type="text"
                name="description"
                isSpace={true}
                isRequired={false}
                onChange={(e) => {
                  if (e.target.value.length <= 250) {
                    formik.handleChange(e);
                  }
                }}
                onBlur={formik.handleBlur}
                placeholder="Enter description"
                maxLength={150}
              />
            </div>
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32">Type</Label>
              <Input
                value={formik.values.type}
                type="text"
                name="type"
                isSpace={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter type"
                className={"!py-0 w-full"}
                maxLength={50}
              />
            </div>
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32">From</Label>
              <Input
                value={formik.values.from}
                name="from"
                isNumeric
                isSpace={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter from"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32">To</Label>
              <Input
                error={formik.errors.to && formik.touched.to}
                errorMsg={formik.errors.to}
                value={formik.values.to}
                name="to"
                isNumeric
                isSpace={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter to"
                className={"!py-0 w-full"}
              />
            </div>
            <div className="flex justify-center">
              {/* <Button type={"submit"}>{row ? "Update" : "Add"}</Button> */}
           <SubmitLoaderButton
                 btnText={row ? "Update" : "Add"}
                isDisable={formik.isSubmitting && !formError}      
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}

export default ModalBadge;
